import { months } from "moment";
import React from "react";

import "./PrintTemplate.css";
import { useTranslation } from "react-i18next";

interface Props {
  toningData: any;
}

const translationPrefix = 'Printing';

const PrintTemplateS11 = (props: Props) => {
  const getFormattedDate = () => {

    var date = new Date();
    var month = date.getMonth() + 1;
    var formattedMonth = month < 10 ? `0${month}` : month;
    var year = date.getFullYear();
    var day = date.getDate();
    var formattedDay = day < 10 ? `0${day}` : day;

    return `${formattedDay}.${formattedMonth}.${year}`;
  }

  const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
debugger;
  return (
    <div className="printContainer">
     <div className="row">
        <div className="col-7 row" style={{ textDecoration: 'underline' }}>
          <span className="printTextS1 boldedText"> {props.toningData.productName}</span>
        </div>
        <div className="col-3 row rightAlignment">
          <span className="printTextS1 rightAlignment">{`${getFormattedDate()}`}</span>
        </div>
      </div>

      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">{t('SampleBook')}</span></div>
        <div className="col-6 row">
          <span className="printTextS1"> {props.toningData.sampleCardName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1"> {t('Color')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">  {props.toningData.colorName}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1"> {t('TotalAmount')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">   {props.toningData.formattedPigmentsVolume}</span>

        </div>
      </div>

      <div className="row">
        <div className="col-4 row">

          <span className="printTextS1">{t('BasePrice')}</span>
        </div>

        <div className="col-6 row">
          <span className="printTextS1"> {props.toningData.formattedBasePrice}
          </span>

        </div>
      </div>
      <div className="row">
        <div className="col-4 row">
          <span className="printTextS1">{t('PigmentsPrice')}</span>
        </div>
        <div className="col-6 row">
          <span className="printTextS1">    {props.toningData.formattedPigmentsPrice}</span></div>
      </div>
    </div>
  );
}

export default PrintTemplateS11;
